<template>
  <div
    class="modal fade"
    id="modal"
    ref="modal"
    data-bs-backdrop="static"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="bg-body-secondary modal-header py-2">
            {{ type == 'IN'? $t('Pay In'): $t('Pay Out') }}
          <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div
          class="modal-body"
          v-if="loading"
        >
          <placeholder-content :is-load="true" />
        </div>
        <div
          class="modal-body"
          v-else-if="!hasPermission"
        >
          <access-denied/>
        </div>
        <div
          class="modal-body"
          v-else
        >

          <div class="row g-3 py-2">
            <div class="col-12">
              <label
                for="amount"
                class="form-label"
              >
                {{ $t('Amount') }}
                <span class="text-danger">*</span>
              </label>
              <div class="input-group-sm">
                <input
                  id="amount"
                  style="font-size: 50px;"
                  type="number"
                  inputmode="numeric"
                  v-model.trim="v$.form.amount.$model"
                  class="form-control shadow-none text-center"
                >
                <div v-for="error of v$.form.amount.$errors"
                  class="d-block invalid-feedback"
                  :key="error.$uid"
                >
                  {{ error.$message }}
                </div>
              </div>
            </div>
            <div class="col-3">
              <button
                type="button"
                class="border-dark-subtle btn-sm btn btn-light w-100"
                @click="() => {
                  v$.form.amount.$touch();
                  form.amount = parseFloat(form.amount || 0) + 5000;
                }"
              >
              5,000
              </button>
            </div>
            <div class="col-3">
              <button
                type="button"
                class="border-dark-subtle btn-sm btn btn-light w-100"
                @click="() => {
                  v$.form.amount.$touch();
                  form.amount = parseFloat(form.amount || 0) + 2000;
                }"
              >
              2,000
              </button>
            </div>
            <div class="col-3">
              <button
                type="button"
                class="border-dark-subtle btn-sm btn btn-light w-100"
                @click="() => {
                  v$.form.amount.$touch();
                  form.amount = parseFloat(form.amount || 0) + 1000;
                }"
              >
              1,000
              </button>
            </div>
            <div class="col-3">
              <button
                type="button"
                class="border-dark-subtle btn-sm btn btn-light w-100"
                @click="() => {
                  v$.form.amount.$touch();
                  form.amount = parseFloat(form.amount || 0) + 500;
                }"
              >
              500
              </button>
            </div>
            <div class="col-12">
              <label
                for="category"
                class="form-label"
              >
                {{ $t('Category') }}
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-select shadow-none"
                v-model="form.shift_transaction_category_id"
                :placeholder="$t('Select Category') + '...'"
              >
                <option value="" disabled>{{ $t('Select Category') + '...' }}</option>
                <option v-for="category in categories" :key="category.id" :value="category.id">
                  {{ category.name }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <label for="note" class="form-label">
                {{ $t('Note') }}
              </label>
              <textarea
                class="form-control shadow-none"
                id="note"
                v-model.trim="v$.form.note.$model"
                style=" font-size: 14px;"
                :placeholder="$t('note') + '...'"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer py-2">
          <ladda
            text="Confirm"
            v-if="type === 'IN'"
            :btn-class="'btn btn-primary btn-block '"
            :loading="loadingSave"
            :disabled="v$.$invalid"
            @click="handlePayIn"
          />
          <ladda
            text="Confirm"
            v-else
            :btn-class="'btn btn-primary btn-block '"
            :loading="loadingSave"
            :disabled="v$.$invalid"
            @click="handlePayOut"
          />
          <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">
            {{ $t('Close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validationPayIn from "./assets/template/validation-pay-in";
import validationPayOut from "./assets/template/validation-pay-out";
import { POSRegisters } from '@/services/endpoint/pos.service';
import { AUTH, API_URLS } from '@/services/endpoint/_constants';
import Select2 from 'vue3-select2-component';
import moment from "moment";
import signature  from '@/services/signature';
import numeral from 'numeral';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    if (this.type == 'IN') {
      return validationPayIn(this.form)
    }
    return validationPayOut(this.form, this.cashInDrawer)
  },
  props: {
    type: {
      type: String,
      default: 'IN'
    }
  },
  data() {
    let vm = this;
    return {
      loadingSave: false,
      form: {
        amount: 0,
        shift_transaction_category_id: ''
      },
      loading: true,
      cashInDrawer: 0,
      select2Items: {
        options: [],
        setting: {
          dropdownParent: '#modal',
          minimumResultsForSearch: true,
          multiple: false,
          language: {
            maximumSelected: function (e) {
              return vm.$t('You can only select') + ' ' + e.maximum + ' ' + vm.$t('items');
            },
            loadingMore: function (e) {
              return '<i class="fa-solid fa-spinner fa-spin" />'
            }
          },
          ajax: {
            beforeSend: function (request) {
              request.setRequestHeader('Authorization', 'Bearer ' + AUTH.TOKEN);
            },
            url: AUTH.URL + API_URLS.API_STOCK_ADJUSTMENT_ITEM,
            data: function (params) {
              var query = {
                search: params.term,
                page: params.page || 1,
                branch_id: vm.$parent.form.branch_id,
                limit: 10
              };
              return signature($.param(query)).substring(1);
            },
            processResults: function (data, params) {
              let option = data.data;
              let pageCurrent = data.meta.current_page;
              option = option.map(function(item) {
                return {
                  id: item.id,
                  text: item.name,
                  cost: item.cost,
                  unit_id: item.unit_id,
                  unit_name: item.unit_name,
                  lots: item.lots
                  // disabled: vm.form.items.find((inventory) => inventory.inventory_id == item.id)? true: false
                }
              });
              return {
                results: option,
                pagination: {
                  more: (pageCurrent * 10) < data.meta.total
                }
              }
            }
          }
        }
      },
      categories: []
    }
  },
  components: {
    Ladda,
    Select2,
    PlaceholderContent,
    AccessDenied
  },
  methods: {
    async fetchDataPayIn() {
      let vm = this;
      await POSRegisters.getCreatePayIn(this.$parent.id).then(res => {
        this.categories = res.data.data.categories.map(function(category) {
          return {
            id: category.id,
            name: vm.$t(category.name)
          }
        });
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
      });

      return;
    },
    async fetchDataPayOut() {
      let vm = this;
      await POSRegisters.getCreatePayOut(this.$parent.id).then(res => {
        this.cashInDrawer = (parseFloat(res.data.data.starting_cash)+parseFloat(res.data.data.total_cash_sales)+parseFloat(res.data.data.total_pay_in))-(parseFloat(res.data.data.total_pay_out)+parseFloat(res.data.data.total_refund))
        this.categories = res.data.filter.categories.map(function(category) {
          return {
            id: category.id,
            name: vm.$t(category.name)
          }
        });
        this.hasPermission = true;
        this.loading = false;
      }).catch(err => {
        this.hasPermission = false;
        this.loading = false;
      });

      return;
    },
    setParamsBeforePayInOut() {
      let params = _.cloneDeep(this.form);
      return $.each(params, (key, value) => {
        if (value === null || value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    async handlePayIn() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await POSRegisters.createPayIn(this.$parent.id, this.setParamsBeforePayInOut()).then(res => {
        this.$parent.getInfoData();
        $(this.$refs.modal).modal('hide');
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Pay In Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
    async handlePayOut() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await POSRegisters.createPayOut(this.$parent.id, this.setParamsBeforePayInOut()).then(res => {
        this.$parent.getInfoData();
        $(this.$refs.modal).modal('hide');
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Pay In Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
    formatDigit(value) {
      if ((value < 0.01) && value != 0) {
        return numeral(value).format("0,0.0000");
      }
      return numeral(value).format("0,0.00");
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD');
    },
  },
  async mounted() {
    $(this.$refs.modal).modal('show');

    $(this.$refs.modal).on('shown.bs.modal',async () => {
      this.loading = true;
      try {
        if (this.type === 'IN') await this.fetchDataPayIn();
        if (this.type === 'OUT') await this.fetchDataPayOut();
      } catch (err) {
      }
    });

    $(this.$refs.modal).on('hidden.bs.modal', () => {
      this.$emit('close');
    });
  },
  computed: {
  },
  watch: {
  }
}
</script>
